/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-driver-search-add',
    templateUrl: './driver-search-add.component.html',
    styleUrls: ['./driver-search-add.component.less'],
    standalone: false
})
export class DriverSearchAddComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
